import styled from 'styled-components';
import toColorString from 'polished/lib/color/toColorString';

import color from '@decisiv/design-tokens/lib/color';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const Container = styled(Flex).attrs({
  flexDirection: 'column',
  marginTop: 2,
})`
  flex: 1;
  overflow-y: auto;
  border: 1px solid ${toColorString(color.base.halfMoon)};
`;
